if (!customElements.get('smooth-scroll-nav')) {
  class SmoothScrollNav extends HTMLElement {
    connectedCallback() {
      this.addEventListeners();
      this.elementsToObserve = Array.from(this.querySelectorAll("a.scroll-anchor")).map((linkElement) => 
        document.querySelector(linkElement.getAttribute("href"))
      );
      this.navListItems = Array.from(this.querySelectorAll("li"));
      window.addEventListener("scroll", this.markVisibleSection.bind(this));
      window.addEventListener("resize", this.markVisibleSection.bind(this));
      this.markVisibleSection();
    }

    addEventListeners() {
      const links = this.querySelectorAll('a.scroll-anchor');
      links.forEach(link => {
        link.addEventListener('click', this.handleClick);
      });
    }

    handleClick(e) {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href').slice(1);
      const targetElement = document.getElementById(targetId);
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

      if (targetElement) {
        const currentUrl = window.location.href.split('#')[0];
        history.pushState(null, '', currentUrl);
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    }

    markVisibleSection() {
  const headerHeight =
    parseFloat(getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')) || 0;

  let currentSection = null;

  this.navListItems.forEach(item =>
    item.classList.remove("is-visible")
  );

  this.elementsToObserve.forEach(section => {
    if (!section) return;

    const rect = section.getBoundingClientRect();
    if (rect.top - headerHeight <= 20) {
      currentSection = section;
    }
  });

  /* ✅ DEFAULT ACTIVE (page load) */
  if (!currentSection && this.elementsToObserve.length) {
    currentSection = this.elementsToObserve[0];
  }

  if (currentSection) {
    const link = this.querySelector(
      `a[href="#${currentSection.id}"]`
    );
    if (link) {
      link.parentElement.classList.add("is-visible");
    }
  }
}

  }

  customElements.define('smooth-scroll-nav', SmoothScrollNav);
}
